/*global TTUserImporter */
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { CustomDialog } from 'moovila-common';

class UserImport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      i: 0,
      message: '',
      fail: false,
    }
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  handleFileChange(e) {
    this.setState({
      message: '',
      fail: false,
    });

    const importerParams = {
      callback: () => {
        this.setState({
          message: 'User import successful :)',
          i: this.state.i + 1,
        });
        this.props.getEnterpriseUsers();
      },
      errorCallback: (errCode, errMessage) => {
        this.setState({
          message: 'User import failed. See console for details.',
          fail: true,
          i: this.state.i + 1,
        });
        console.error('[UserImport] There was an error importing the user. -', errCode, '-', errMessage)
      },
      autoValidate: false,
      defaultPassword: '',
      enterpriseGUID: this.props.enterpriseGUID,
    };
    
    const userImporter = new TTUserImporter(importerParams);
    userImporter.ImportFileFromInput(e.currentTarget);
  }

  render() {
    const buttons = (
      <div>
        <p>
          <Link to={`/admin/enterprise-maintenance/users/${this.props.enterpriseGUID}`} className='btn btn-default btn-block btn-md' onClick={() => {}}>
            Back to users
          </Link>
        </p>
      </div>
    );
    const messageStyle = {
      color: this.state.fail ? '#f44' : '#000',
    }
    return (
      <CustomDialog
        size='md'
        title={<span><i className='fa fa-cloud-upload'></i> User Import</span>}
        backTo={`/admin/enterprise-maintenance/users/${this.props.enterpriseGUID}`}
        buttons={buttons}
      >
        <section className='section'>
          <div className='row'>
            <div className='col-xs-12 form-group'>
              <h2>Choose a file to start the import</h2>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 form-group'>
              <input key={this.state.i} type='file' onChange={e => this.handleFileChange(e)} />
            </div>
          </div>
          { this.state.message ?
            <div className='row'>
              <div className='col-xs-12 form-group'>
                <p style={messageStyle}>{ this.state.message }</p>
              </div>
            </div>
          : null }
        </section>
      </CustomDialog>
    );
  }
}

export default UserImport;



// WEBPACK FOOTER //
// ./src/containers/Admin/UserImport.js